import React from 'react';
import PropTypes from 'prop-types';

// #9500FF
function IconFavorite({ size = 120, className, style }) {
  return (
    <div className={className} style={{style}}>
      <svg width={size} height={size} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="120" height="120" rx="60" fill="#262626"/>
        <path d="M60 26.6669L70.3 47.5336L93.3333 50.9002L76.6666 67.1336L80.6 90.0669L60 79.2336L39.4 90.0669L43.3333 67.1336L26.6666 50.9002L49.7 47.5336L60 26.6669Z" fill="#88898B"/>
      </svg>
    </div>
  )
}

IconFavorite.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default IconFavorite;
